module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/card/card-header.component.html
// module id = ../../../../../src/app/layout/card/card-header.component.html
// module chunks = 3